import { WarningOutlined } from '@ant-design/icons'
import { Flex, Typography, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AuthShell } from './AuthShell'

/**
 * Login va TOTP TO'G'RI, lekin hisobning HECH QANDAY faol a'zoligi yo'q
 * (backend `totp/confirm` yoki `totp/verify` da 403 qaytaradi).
 *
 * ⚠️ Bu holatni jimgina login sahifasiga qaytarib qo'yish YOMON — operator
 * "parolni noto'g'ri kiritdimmi?" deb qayta-qayta urinardi, aslida muammo
 * administratorda. Shuning uchun ANIQ ekran: nima bo'lgani va nima qilish
 * kerakligi tushuntiriladi.
 *
 * To'g'ridan-to'g'ri (masalan havola saqlab qo'yilib) ochilsa ham xavfsiz —
 * bu sahifa hech qanday oraliq token talab qilmaydi, faqat matn.
 */
export function NoMembershipPage() {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const navigate = useNavigate()

  return (
    <AuthShell title={t('auth.noMembership.title')}>
      <Flex vertical align="center" gap={16} style={{ textAlign: 'center' }}>
        <WarningOutlined style={{ fontSize: 40, color: token.colorWarning }} />
        <Typography.Text>{t('auth.noMembership.text')}</Typography.Text>
        <Typography.Link onClick={() => navigate('/login', { replace: true })}>
          ← {t('auth.signIn')}
        </Typography.Link>
      </Flex>
    </AuthShell>
  )
}
